import React from 'react'

import ProjectCarouselButtons from '../ProjectCarouselButtons'

const FlappyBird = () => {
    return (
        <>
            <div className="Project--split--window">
                <div className="Project-Carousel-info-container">
                    <div id="carouselExampleIndicatorsFlappyBird" className="carousel slide Project-Carousel-container">

                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <video controls="controls" className="d-block w-100">
                                    <source src="../IMG/FlappyBird/FlappyBird.mp4" type="video/mp4" />
                                </video>
                            </div>
                        </div>

                        <ProjectCarouselButtons tag="FlappyBird" />

                    </div>

                    <div className="Project-info-container">
                        <div className="Project--info--Para-container">
                            <p className="Project--info--heading">FlappyBird</p>
                            <p className="Project--info--subheading">ML/AI Development</p>
                            <p className="Project--info--subheading">Game Development</p>
                            <p className="Project--info--subheading">NEAT & Pygame</p>
                            <p className="Project--info--Para">
                                Game Concept: Flappy Bird is a popular side-scrolling game where the player controls a bird, attempting to fly between columns of green pipes without hitting them.
                                Objective: Achieve the highest possible score by passing through the gaps between pipes.
                            </p>
                            <p className="Project--info--Para">
                                AI Integration: The game includes an AI component that uses NEAT to train neural networks to play Flappy Bird.
                                Neural networks control the bird's jumping behavior based on input parameters such as bird position and pipe positions.
                            </p>
                        </div>
                        {/* <div className="Project--info--links">
                            <a href="https://github.com/Chauhan-Aman/JAMSHACK23_UnityServe" target='__blank'>Github</a>
                        </div> */}
                        <div className="Project--info--tech">
                            <p>Python</p>
                            <p>Pygame</p>
                            <p>NEAT</p>
                            <p>OOPS</p>
                            <p>Random</p>
                            <p>Graphics Manipulation</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FlappyBird